<template>
  <div class="viewurl-page-table">

    <div class="searchwrap">
      <el-row :gutter="15">
        <el-col :span="12">
          <el-form :inline="true" class="table-form-inline search-left">
            <el-form-item :label="$t('jgjk.s12')">
              <el-select v-model="filterselector[0].default" :placeholder="$t('dsfx.t14')" size="mini" @change="filters0change">
                <el-option
                  v-for="item in filterselector[0].options"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('dsfx.t23')">
              <el-select v-model="filterselector[3].default" :placeholder="$t('dsfx.t14')" size="mini" @change="filters3change">
                <el-option
                  v-for="item in filterselector[3].options"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button @click="chkviewmodel(2)" size="mini" :class="viewmodel == 2 ? 'chk-spu-sku chk-spu chk-spu-active' : 'chk-spu-sku chk-spu'"></el-button>
              <el-button @click="chkviewmodel(1)" size="mini" :class="viewmodel == 1 ? 'chk-spu-sku chk-sku chk-sku-active' : 'chk-spu-sku chk-sku'"></el-button>
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="12">
          <div class="tousuxiajiabuttonwrap">
            <el-input 
              v-model="viewState.searchNeedle" 
              :placeholder="$t('jgjk.s2651')" 
              size="mini" 
              @keyup.enter.native="onTableListSaerchClick()"
            >
            </el-input>
            <el-button type="danger" @click="onTableListSaerchClick()" size="mini">{{ $t('dsfx.t26') }}</el-button>
            <!-- <el-button 
              type="danger" 
              size="mini" 
              @click="multEditSkuLink()" 
              :disabled="ischeckeditems"
              v-if="isangecy && viewmodel == 1"
            >
              批量修改
            </el-button> -->
          </div>
        </el-col>
      </el-row>
    </div>

    <div class="tablebox" v-if="viewmodel == 2">
      <el-table
        :cell-style="getTableCellStyle"
        v-loading="tableloading"
        :data="tableData" 
        tooltip-effect="dark" 
        style="width: 100%"
        @expand-change="getProductList"
        :expand-row-keys="expands"
        :row-key="getRowKeys"
        :key="2"
        @sort-change="sortthiscolumnSPU"
      >
        <el-table-column width="30" type="expand">
          <template slot-scope="scope">
            <div class="tablebox">
              <el-table
                :cell-style="getTableCellStyle"
                v-loading="tableloading1"
                :data="tableDataSku[scope.row.index]"
                tooltip-effect="dark" 
                style="width: 100%"
                border
                size="mini"
                stripe
                @cell-dblclick="editTableColumn"
              >
                <el-table-column prop="AssetId" label="ASSETID" width="100" show-overflow-tooltip></el-table-column>
                <el-table-column prop='skuMap' :label="$t('jgjk.s266')" show-overflow-tooltip></el-table-column>
                <el-table-column prop='CurrentPrice' :label="$t('jgjk.s23')" width="95" show-overflow-tooltip></el-table-column>
                <el-table-column prop='FinalPrice' :label="$t('jgjk.s24')" width="120" show-overflow-tooltip></el-table-column>
                <el-table-column prop='MarginPrice' :label="$t('jgjk.s26')" width="80" show-overflow-tooltip></el-table-column>
                <el-table-column prop='MarginPercent' :label="$t('report.s38')" width="100" show-overflow-tooltip></el-table-column>
        
                <el-table-column prop='notes' :label="$t('Seller.t13')" width="130" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <span v-if="scope.row.iseditnotes == false">{{ scope.row.notes }}</span>
                    <el-input 
                      v-inputfocus
                      class="editnoteinput" 
                      v-model="scope.row.notes" 
                      v-if="scope.row.iseditnotes === true" 
                      @blur="setnote(scope.row.AssetId, scope.row.notes, scope.$index)"
                      @keyup.enter.native="setnote(scope.row.AssetId, scope.row.notes, scope.$index)"
                      size="mini"
                      maxlength="20">
                    </el-input>
                  </template>
                </el-table-column>

                <el-table-column :label="$t('jgjk.s31')" width="90">
                  <template slot-scope="scope1">
                    <button v-if="userinfo.role/1 == 0 || userinfo.role/1 == 2" class="editskulinkbtn" type="button" @click="editSkuLink(scope1.row)"><i class="el-icon-edit-outline"></i></button>
                    <button class="viewactivebrand" type="button" @click="viewUrlDetail(scope1.row.AssetId, scope1.row.ProductName)"></button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="spuid" label="SPUID" width="150" show-overflow-tooltip></el-table-column>
        <el-table-column prop="productName" :label="$t('jgjk.s15')" show-overflow-tooltip></el-table-column>
        <el-table-column :label="$t('jgjk.s12')" width="80">
          <template slot-scope="scope">
            <i class="channelicon" :class="scope.row.channelicon"></i>
          </template>          
        </el-table-column>
        <el-table-column :label="$t('activebrand.t50')" width="200" show-overflow-tooltip>
          <template slot-scope="scope">
            <a :href="scope.row.ShopUrl" target="_blank">{{ scope.row.shopname }}</a>
          </template>
        </el-table-column>
        <el-table-column sortable='custom' prop="pageprice" :label="$t('jgjk.s23')" width="100"></el-table-column>
        <el-table-column prop="MarginPercent" :label="$t('report.s51')" width="100"></el-table-column>
        <el-table-column prop='authorize' :label="$t('jgjk.s21')" width="60" show-overflow-tooltip></el-table-column>
        <el-table-column prop="count" :label="$t('SPU.s10')" width="100"></el-table-column>
      </el-table>
    </div>

    <div class="tablebox" v-if="viewmodel == 1">
      <el-table
        :cell-style="getTableCellStyle"
        v-loading="tableloading2"
        :data="tableDataskulist"
        tooltip-effect="dark" 
        style="width: 100%" 
        @sort-change="sortthiscolumn"
        @selection-change="handleSelectionChange" 
        @cell-dblclick="editTableColumn"
        :key="1"
      >
        <el-table-column 
          v-if="isangecy"
          header-align="right" 
          prop="AssetId" 
          type="selection" 
          width="40" 
          column-key='AssetId' 
          :selectable="selectable"
        >
        </el-table-column>
        <el-table-column label="ASSETID" width="110" show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-html="scope.row.AssetIdIcon"></span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('jgjk.s15')" show-overflow-tooltip>
          <template slot-scope="scope">
            <a :href="scope.row.URL" target="_blank">{{ scope.row.ProductName }}</a>
          </template>
        </el-table-column>
        <el-table-column prop='SkuMap' :label="$t('jgjk.s266')" show-overflow-tooltip></el-table-column>
        <el-table-column :label="$t('jgjk.s12')" width="80">
          <template slot-scope="scope">
            <i class="channelicon" :class="scope.row.channelicon"></i>
          </template>
        </el-table-column>
        <el-table-column :label="$t('activebrand.t50')" width="120" show-overflow-tooltip>
          <template slot-scope="scope">
            <a :href="scope.row.ShopUrl" target="_blank">{{ scope.row.ShopName }}</a>
          </template>
        </el-table-column>
        <el-table-column align="center" sortable='custom' prop='SkuTotalAmountStr' :label="$t('jgjk.s267')" width="110"></el-table-column>
         <el-table-column prop='authorize' :label="$t('jgjk.s21')" width="60" show-overflow-tooltip></el-table-column>
        <el-table-column sortable='custom' prop='CurrentPrice' :label="$t('jgjk.s23')" width="95" show-overflow-tooltip></el-table-column>
        <el-table-column sortable='custom' prop='FinalPrice' :label="$t('jgjk.s24')" width="120" show-overflow-tooltip></el-table-column>
        <el-table-column sortable='custom' prop='MarginPrice' :label="$t('jgjk.s26')" width="80" show-overflow-tooltip></el-table-column>
        <el-table-column sortable='custom' prop='MarginPercent' :label="$t('report.s38')" width="100" show-overflow-tooltip></el-table-column>
        
        <el-table-column prop='notes' :label="$t('Seller.t13')" width="130" show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-if="scope.row.iseditnotes == false">{{ scope.row.notes }}</span>
            <el-input 
              v-inputfocus
              class="editnoteinput" 
              v-model="scope.row.notes" 
              v-if="scope.row.iseditnotes === true" 
              @blur="setnote(scope.row.AssetId, scope.row.notes, scope.$index)"
              @keyup.enter.native="setnote(scope.row.AssetId, scope.row.notes, scope.$index)"
              size="mini"
              maxlength="20">
            </el-input>
          </template>
        </el-table-column>

        <el-table-column :label="$t('jgjk.s31')" width="80">
          <template slot-scope="scope">
            <button v-if="userinfo.role/1 == 0 || userinfo.role/1 == 2" class="editskulinkbtn" type="button" @click="editSkuLink(scope.row)"><i class="el-icon-edit-outline"></i></button>
            <button class="viewactivebrand" type="button" @click="viewUrlDetail(scope.row.AssetId, scope.row.ProductName)"></button>
          </template>
        </el-table-column>
      </el-table>
    </div>    

    <div class="pagewrap">
      <el-pagination
        small
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage1"
        popper-class="pagesizeclass"
        :page-sizes="[25, 50, 100]"
        :page-size="pagesize"
        layout="total, prev, pager, next, sizes"
        :total="viewmodel == 1 ? pagingtotalsku : pagingtotalspu">
      </el-pagination>
      <el-button
        type="confirmselect" 
        size="mini" 
        @click="multEditSkuLink()" 
        :disabled="ischeckeditems"
        v-if="isangecy && viewmodel == 1"
      >
        批量修改
      </el-button>
    </div>
    
    <el-dialog
      custom-class="editskulink-datafeedback"
      :title="$t('editsku.s1')"
      :visible.sync="editskulinkdialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal-append-to-body="true"
      :append-to-body="true"
      @close="radio = ''; value = ''">
      <div class="editskulink-body">
        <div class="editskulink-body-table" v-if="multedit == false">
          <table>
            <tr>
              <td width="120">{{ $t('jgjk.s13') }}</td>
              <td>{{topinfo.series}}</td>
            </tr>
            <tr>
              <td>{{ $t('jgjk.s15') }}</td>
              <td>{{ currentlinkeditcontent.ProductName }}</td>
            </tr>
            <tr>
              <td>{{ $t('jgjk.s266') }}</td>
              <td>{{ currentlinkeditcontent.SkuMap }}</td>
            </tr>
            <tr>
              <td>{{ $t('jgjk.s24') }}</td>
              <td>{{ currentlinkeditcontent.FinalPrice }}</td>
            </tr>
            <tr>
              <td>{{ $t('activebrand.t50') }}</td>
              <td>{{ currentlinkeditcontent.ShopName }}</td>
            </tr>
            <tr>
              <td>SKUID</td>
              <td>{{currentlinkeditcontent.SkuId}}</td>
            </tr>
            <tr>
              <td>{{ $t('jgjk.s271') }}</td>
              <td>{{topinfo.name}}</td>
            </tr>
            <tr>
              <td>{{ $t('editsku.s5') }}</td>
              <td>{{currentlinkeditcontent.ConfigValue}}</td>
            </tr>
          </table>
        </div>
        <div class="editskulink-radio">
          <el-radio v-model="newskuidradio" label="-1" size="mini" border>{{ $t('editsku.s2') }}</el-radio>
          <el-radio v-model="newskuidradio" label="0" size="mini" border>{{ $t('editsku.s3') }}</el-radio>
          <el-radio v-model="newskuidradio" label="3" size="mini" border>{{ $t('editsku.s4') }}</el-radio>
            <!-- remote
            :remote-method="searchSku" -->
          <el-select 
            v-if="newskuidradio/1 === 3" 
            v-model="newskuid" 
            filterable
            clearable
            placeholder="搜索SKU" 
            size="mini">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>          
        </div>

      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="editskulinkdialog = false; newskuidradio = ''; newskuid = ''">{{$t('dsfx.t32')}}</el-button>
        <el-button size="mini" 
          :disabled="newskuidradio!='-1'&&newskuidradio!='0'&&newskuid==''" 
          type="primary" @click="editskulinkconfirm()">{{$t('dsfx.t33')}}</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
export default {
  data() {
    return {
      getRowKeys(row){
        return row.index
      },
      expands: [],
      radio: '',
      pagesize: 25,
      notviptable: false,
      balance: '',
      isdisabled: true,
      userinfo: {},

      options: [],
      value: '',
      newskuidradio: '',
      newskuid: '',

      ischeckeditems: true,
      loadingnormalQuota: false,

      feedbackcomplaindialog: false,
      userbalance: '',
      feedbackcomplainsuccess: false,

      feedbacksuccess: false,
      feedbackBtnDisable: true,//true:隐藏
      feedbackBtnId: 0,//反馈类型：判定错误/链接失效
      feedbackTextarea: '',//系统反馈内容
      feedbackSelectedIds: '',//反馈的数据ID
      feedbackOptionsval: null,
      feedbackOptions: [],
      feedbackdialogopen: false,//意见反馈对话框是否打开
      tableloading: true,
      tableloading1: true,
      tableloading2: true,
      tableorder: 50,
      tableorderspu: '00',
      viewState: {
          selectedTab: "tab_all",
          searchNeedle: '',
          model4Tab: {}
      },
      refresh: false,
      formInline: {
        user: '',
        region: ''
      },
      selectToolsChannel:'',
      selectToolsResult:'',
      selectToolsStatus:'',
      filterSelect:{
        channel : [], //渠道
        result: [],   //判定结果
        status : [],  //确信度
      },
      filterselector: [{
          fieldid: "Channel",
          source: "channel",
          options: [],
          default: ''
      },{
          fieldid: "Result",
          source: "result",
          options: [{
            name: this.$t('tabletabs.all'),
            value: ''
          },{
            name: this.$t('DashboardProduct.barlegendnamefalse'),
            value: 0,
          },{
            name: this.$t('DashboardProduct.barlegendnametrue'),
            value: 1,
          }],
          default: ''
      },{
          fieldid: "Bucket",
          source: "bucket",
          options: [{
            name: '全部',
            value: ''
          },{
            name: '低',
            value: 3,
          },{
            name: '中',
            value: 2,
          },{
            name: '高',
            value: 1,
          }],
          default: ''
      },{
          fieldid: "Authorize",
          source: "authorize",
          options: [{
            name: this.$t('tabletabs.all'),
            value: ''
          },{
            name: this.$t('dsfx.t53'),
            value: 0,
          },{
            name: this.$t('dsfx.t52'),
            value: 1,
          }],
          default: ''
      }],
      tableviewQuery: {
        start: this.$store.state.startDate+' 00:00:00',
        end: this.$store.state.endDate+' 23:59:59',
        page: localStorage.getItem("viewurlpage") ? JSON.parse(localStorage.getItem("viewurlpage")).val/1 : 1,
        rpstatus: "",
        channel: "",//渠道：淘宝/天猫
        result: "", //判断结果：真/假
        bucket: "", //确信度：高中低
        search: "",
        brand: "",
        authorize: ""
      },
      tabs: [
        {
          id: "tab_all",
          filter: '',                
          sum: 0,
          isActive: true
        },
        {
          id: "tab_pending",
          filter: 1,
          sum: 0,
        },
        {
          id: "tab_waiting",
          filter: 2,
          sum: 0,
        },
        {
          id: "tab_progress",
          filter: 5,
          sum: 0,
        },
        {
          id: "tab_success",
          filter: 4,
          sum: 0,
        },
        {
          id: "tab_failed",
          filter: 3,
          sum: 0,
        }
      ],
      tableData: [],
      tableDataSku: [],
      tableDataskulist: [],
      multipleSelection: [],
      currentPage1: localStorage.getItem("viewurlpage") ? JSON.parse(localStorage.getItem("viewurlpage")).val/1 : 1,
      pagingtotalsku: 0,
      pagingtotalspu: 0,
      DiscriminantResultText: '',
      channelIdAndNameMap: {},
      disableOptionsRefresh: false,
      editskulinkdialog: false,
      currentlinkeditcontent: '',
      topinfo: '',
      viewmodel: 2, //1 sku,2 spu,
      isangecy: JSON.parse(localStorage.getItem("userinfo")).val.role == 2 
                || JSON.parse(localStorage.getItem("userinfo")).val.role == 0,
      // role==2 or role==0
      multedit: false
    }
  },
  mounted(){
    this.viewmodel = localStorage.getItem("viewmodel") ? JSON.parse(localStorage.getItem("viewmodel")).val : 2
    this.getTopInfo()
    this.getUserInfo()
    this.requestTabAndDropdownData()
    this.tableviewModelChange()
    this.tableviewModelChangeSKU()
  },
  methods: {

    getTopInfo: function(){
      this.topinfo = JSON.parse(localStorage.getItem("SPUviewurl")).val
    },

    getUserInfo: function(){
      this.userinfo = JSON.parse(localStorage.getItem("userinfo")).val
    },
    
    /**
     * 列表排序
     */
    sortthiscolumnSPU: function(column){
      if(column.prop == "pageprice" && column.order == "ascending"){
        this.tableorderspu = '00'
        this.reloadTableData()
      }else if(column.prop == "pageprice" && column.order == "descending"){
        this.tableorderspu = '01'
        this.reloadTableData()
      }else if(column.prop == "pageprice" && column.order == null){
        this.tableorderspu = ''
        this.reloadTableData()
      }else{
        return
      }
    },

    sortthiscolumn: function(column){
      if(column.prop == "CurrentPrice" && column.order == "ascending"){
        this.tableorder = 10
        this.reloadTableData()
      }else if(column.prop == "CurrentPrice" && column.order == "descending"){
        this.tableorder = 11
        this.reloadTableData()
      }else if(column.prop == "CurrentPrice" && column.order == null){
        this.tableorder = ''
        this.reloadTableData()
      }else if(column.prop == "FinalPrice" && column.order == "ascending"){
        this.tableorder = 20
        this.reloadTableData()
      }else if(column.prop == "FinalPrice" && column.order == "descending"){
        this.tableorder = 21
        this.reloadTableData()
      }else if(column.prop == "FinalPrice" && column.order == null){
        this.tableorder = ''
        this.reloadTableData()
      }else if(column.prop == "MonitorPrice" && column.order == "ascending"){
        this.tableorder = 30
        this.reloadTableData()
      }else if(column.prop == "MonitorPrice" && column.order == "descending"){
        this.tableorder = 31
        this.reloadTableData()
      }else if(column.prop == "MonitorPrice" && column.order == null){
        this.tableorder = ''
        this.reloadTableData()
      }else if(column.prop == "MarginPrice" && column.order == "ascending"){
        this.tableorder = 40
        this.reloadTableData()
      }else if(column.prop == "MarginPrice" && column.order == "descending"){
        this.tableorder = 41
        this.reloadTableData()
      }else if(column.prop == "MarginPrice" && column.order == null){
        this.tableorder = ''
        this.reloadTableData()
      }else if(column.prop == "MarginPercent" && column.order == "ascending"){
        this.tableorder = 50
        this.reloadTableData()
      }else if(column.prop == "MarginPercent" && column.order == "descending"){
        this.tableorder = 51
        this.reloadTableData()
      }else if(column.prop == "MarginPercent" && column.order == null){
        this.tableorder = ''
        this.reloadTableData()
      }else if(column.prop == "last30days" && column.order == "ascending"){
        this.tableorder = 60
        this.reloadTableData()
      }else if(column.prop == "last30days" && column.order == "descending"){
        this.tableorder = 61
        this.reloadTableData()
      }else if(column.prop == "last30days" && column.order == null){
        this.tableorder = ''
        this.reloadTableData()
      }else if(column.prop == "last30times" && column.order == "ascending"){
        this.tableorder = 70
        this.reloadTableData()
      }else if(column.prop == "last30times" && column.order == "descending"){
        this.tableorder = 71
        this.reloadTableData()
      }else if(column.prop == "last30times" && column.order == null){
        this.tableorder = ''
        this.reloadTableData()
      }else if(column.prop == "SkuTotalAmountStr" && column.order == "ascending"){
        this.tableorder = 80
        this.reloadTableData()
      }else if(column.prop == "SkuTotalAmountStr" && column.order == "descending"){
        this.tableorder = 81
        this.reloadTableData()
      }else if(column.prop == "SkuTotalAmountStr" && column.order == null){
        this.tableorder = ''
        this.reloadTableData()
      }else{
        return
      }
    },
    
    /**
     * 配置按钮事件
     */
    onClickSetting: function(){
      this.notviptable = true
    },

    //24小时只能投诉一次
    selectable(row) {
      //console.log('selectable', row)
      if(this.tableviewQuery.rpstatus === 1){
        return true
      }else{
        if(row.Feedback === 1){
          return false;
        }else{
          return true;
        }
      }
    },

    onSubmitFeedbackComplain: function(){
      if(this.feedbackSelectedIds.length < 1) return
      console.log('onSubmitFeedbackComplain',this.balance);
      this.feedbackcomplaindialog = true
      this.userbalance = this.balance
      //this.userbalance = JSON.parse(localStorage.getItem("balance")).val
    },

    onSubmitFeedbackComplainCancel: function(){
      this.feedbackcomplaindialog=false
      this.toggleSelection()
    },

    onSubmitFeedback: function(){
      this.feedbackdialogopen = true
      if(this.feedbackSelectedIds.length < 1){
        this.feedbackBtnDisable = true
      }else{
        this.feedbackBtnDisable = false
      }
    },

    onTableListSaerchClick: function(){
      // this.$router.replace({
      //   query:{
      //     page: 1
      //   }
      // })
      this.currentPage1 = 1
      this.onTableListSaerch()
    },

    onTableListSaerch: function(){
      this.tableviewQuery.page = 1
      if(this.viewmodel == 1){
        this.tableviewModelChangeSKU()
      }
      if(this.viewmodel == 2){
        this.tableviewModelChange()
      }
    },

    filters0change: function(val){
      this.filterselector[0].default = val === '全部' ? '' : val
      console.log('filters0change', val)
      this.disableOptionsRefresh = true
      if(localStorage.getItem("viewurlpage")){
        localStorage.removeItem('viewurlpage')
      }
      this.reloadTableData()
    },
    filters1change: function(val){
      this.filterselector[1].default = val === '全部' ? '' : val
      console.log(val)
      this.disableOptionsRefresh = true
      if(localStorage.getItem("viewurlpage")){
        localStorage.removeItem('viewurlpage')
      }
      this.reloadTableData()
    },
    filters2change: function(val){
      this.filterselector[2].default = val === '全部' ? '' : val
      console.log(val)
      this.disableOptionsRefresh = true
      if(localStorage.getItem("viewurlpage")){
        localStorage.removeItem('viewurlpage')
      }
      this.reloadTableData()
    },
    filters3change: function(val){
      this.filterselector[3].default = val === '全部' ? '' : val
      console.log(val)
      this.disableOptionsRefresh = true
      if(localStorage.getItem("viewurlpage")){
        localStorage.removeItem('viewurlpage')
      }
      this.reloadTableData()
    },

    reloadTableData: function(){
      this.tableviewQuery.page = '1',
      this.currentPage1 = 1,
      this.channel = this.filterselector[0].default,
      this.result = this.filterselector[1].default,
      this.bucket = this.filterselector[2].default,
      this.tableviewQuery.authorize = this.filterselector[3].default,
      this.requestTabAndDropdownData()
      this.tableviewModelChange()
      this.tableviewModelChangeSKU()
    },

    handleSizeChange(val) {
      let that = this
      that.currentPage1 = 1
      that.tableviewQuery.page = 1
      that.pagesize = val
      if(this.viewmodel == 1){
        this.tableviewModelChangeSKU()
      }
      if(this.viewmodel == 2){
        this.tableviewModelChange()
      }
    },
    handleCurrentChange(val) {
      this.tableviewQuery.page = val
      // this.$router.replace({
      //   query:{
      //     page: val
      //   }
      // })
      if(this.viewmodel == 1){
        this.tableviewModelChangeSKU()
        this.setLocalStorage( "viewurlpage", val )
      }
      if(this.viewmodel == 2){
        this.tableviewModelChange()
      }
    },
    
    /**
     * 获取表头
     */
    requestTabAndDropdownData: function(){
      let that = this
      let url = that.API_URL + '/v3/price/statistics/filter'
      let data = {
        skuid: that.$route.params.SkuId,
        channel: that.filterselector[0].default,
        authorize: this.tableviewQuery.authorize,
        search: this.viewState.searchNeedle,
      }
      $.ajax({
        url:  url,
        type: "GET",
        data: data,
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        success: function(rex) {
          console.log('requestTabAndDropdownData', rex)
          for(let i=0; i<rex.results[0].length; i++){
            that.tabs[i].sum = rex.results[0][i]
          }
          
          let selectdefaultval = {
            name : that.$t('tabletabs.all'),
            value : ''
          }
          that.filterselector[0].options = rex.results[1].map(function(val){
            return {
              name: that.setChannel(val.Channel).loc,
              value: val.Channel
            }
          })
          that.filterselector[0].options.unshift(selectdefaultval)

        },
        error: function(response) {
          console.log('requestTabAndDropdownData', response)
        }
      })      
    },

    tableviewModelChange: function () {
        
      let that = this;
      let newQuery = {
        page: that.tableviewQuery.page,
        size: that.pagesize,
        order: that.tableorderspu,
        search: that.viewState.searchNeedle,
        channel: that.filterselector[0].default,
        authorize: that.tableviewQuery.authorize,
        subid: that.$route.params.Id,
        skuid: that.$route.params.SkuId
      }
      that.activeTableLoader();

      let url = this.API_URL + '/v3/price/monitorspu/list';
      $.ajax({
        url:  url,
        type: "GET",
        data: newQuery,
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        success: function(rex) {
          let _lists = rex.results[0]
          _lists.forEach((item, index) => {
            item.channelicon = that.setChannel(item.channel).src
            item.pageprice = item.minFinalPrice == item.maxFinalPrice ? item.maxFinalPrice : item.maxFinalPrice + '-' + item.maxFinalPrice
            item.MarginPercent = (item.MarginPercent * 100).toFixed(2) + "%"
            item.authorize = item.IsAuthor/1 === 0 ? that.$t('dsfx.t53') : that.$t('dsfx.t52')
            item.index = index
          })
          that.tableData = _lists
          that.pagingtotalspu = rex.results[1][0].Count

          that.shutTableLoader()
        },
        error: function(response) {
          console.log(response)
        }
      });
    },

    /**
     * 获取单品链接
     */
    getProductList: function(row){
      let that = this
      let url = this.API_URL + '/v3/price/monitorspu/skulist'
      let query = {
        skuid: that.$route.params.SkuId,
        subid: that.$route.params.Id,
        itemcode: row.itemcode,
        channelid: row.channelid
      }

      let _c = this.expands
      if(row.index == _c[0]) return
      this.expands = []
      this.expands.push(row.index)

      that.tableloading1 = true
      $.ajax({
        url:  url,
        type: "GET",
        data: query,
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        success: function(rex) {
          console.log(rex)
          let _list = rex.results[1]
          _list.forEach(item => {
            item.MarginPercent = (item.MarginPercent * 100).toFixed(2) + "%"
          })
          that.tableDataSku[row.index] = _list
          that.tableloading1 = false
        },
        error: function(response) {
          console.log(response)
        }
      })
    },
    
    // loader for table 
    activeTableLoader: function() {
      this.tableloading = true
    },
    shutTableLoader: function() {
      this.tableloading = false
      //this.viewModel.tableview.tableLoading = false;
    },

    setResults: function(rst){
      let resultobj = {}
      switch (rst) {
        case 1:
          resultobj.styleclass = "btn_tab_pending";
          resultobj.text = this.$t('tabletabs.pending');
          break;
        case 2:
          resultobj.styleclass = "btn_tab_waiting";
          resultobj.text = this.$t('tabletabs.waiting');
          break;
        case 5:
          resultobj.styleclass = "btn_tab_progress";
          resultobj.text = this.$t('tabletabs.progress');
          break;
        case 4:
          resultobj.styleclass = "btn_tab_success";
          resultobj.text = this.$t('tabletabs.success');
          break;
        case 3:
          resultobj.styleclass = "btn_tab_failed";
          resultobj.text = this.$t('tabletabs.failed');
          break;
        default:
          resultobj.styleclass = "btn_tab_all";
          resultobj.text = "";
          break;
      }      
      return resultobj
    },

    /**
     * 查看详情
     */
    viewUrlDetail: function(mid, name){
      this.setLocalStorage( "SPUviewurlDetail", '' )
      let MidName = name
      this.setLocalStorage( "SPUviewurlDetail", MidName )
      this.$router.push({name: 'SPUViewUrlDetail', params: {Id: this.$route.params.Id, SkuId: this.$route.params.SkuId, Mid: mid}})
    },

    /**
     * 判断是否一天内
     */
    chkCrawltime: function(ctime, ntime){
      if(ctime){
        if(this.$moment(ntime).diff(this.$moment(ctime),'hours') < 24){
          return true
        }else{
          return false
        }
      }else{
        return false
      }
    },

    /**
     * 修改链接
     */
    editSkuLink: function(row){
      let that = this
      that.multedit = false
      that.searchSku()
      that.editskulinkdialog = true
      that.options = []
      that.currentlinkeditcontent = row
    },

    multEditSkuLink: function(){
      let that = this
      that.multedit = true
      that.searchSku()
      that.editskulinkdialog = true
      that.options = []
    },

    /**
     * 搜索SKU
     */
    searchSku: function(keyword){
      let that = this
      let url = that.API_URL + '/v3/price/statistics/getSKUBaseInfo'
      let query = {
        subid: that.$route.params.Id,
        SKUName: keyword
      }
      if(keyword == ''){
        return
      }
      $.ajax({
        url: url,
        type: "GET",
        changeOrigin: true,
        dataType: "json",
        contentType: "application/json",
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("token")).val + ""
        },
        data: query,
        success: function(rex) {
          console.log('searchSku', rex)
          that.options = rex.results.map(item => {
            return { 
              value: item.SKUID, 
              label: item.SKUName + '(' + item.UserSKUCode + ' | ' + item.SKUID + ')'
            }
          })
        },
        error: function(response) {
          console.log('searchSku', response)
        }
      })      
    },

    /**
     * 确认修改SKU
     */
    editskulinkconfirm: function(){
      let that = this
      let url = that.API_URL + '/v3/price/statistics/updatesku'
      let query = {
        skulist: [],
        subid: that.$route.params.Id/1,
      }
      if(that.multedit == true){
        for(let i=0; i<this.feedbackSelectedIds.length; i++){
          let _query = {
          channelId: this.feedbackSelectedIds[i].ChannelId,
          channel: this.feedbackSelectedIds[i].Channel,
          shopId: this.feedbackSelectedIds[i].ShopId,
          assetid: this.feedbackSelectedIds[i].AssetId,
          skuid: that.$route.params.SkuId/1,
          newskuid: that.newskuidradio/1 === 3 ? that.newskuid : that.newskuidradio,
          currentDate: JSON.parse(localStorage.getItem("latestupdatetimeeditsku")).val            
          }
          query.skulist.push(_query)
        }
      }else{
        query.skulist[0] = {
          channelId: that.currentlinkeditcontent.ChannelId,
          channel: that.currentlinkeditcontent.Channel,
          shopId: that.currentlinkeditcontent.ShopId,
          assetid: that.currentlinkeditcontent.AssetId,
          skuid: that.$route.params.SkuId/1,
          newskuid: that.newskuidradio/1 === 3 ? that.newskuid : that.newskuidradio,
          currentDate: JSON.parse(localStorage.getItem("latestupdatetimeeditsku")).val
        }
      }
      $.ajax({
        url: url,
        type: "POST",
        changeOrigin: true,
        dataType: "json",
        contentType: "application/json",
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("token")).val + ""
        },
        data: JSON.stringify(query),
        success: function(rex) {
          console.log('editskulinkconfirm', rex)
          that.editskulinkdialog = false
          that.options = []
          that.currentlinkeditcontent = {}
          that.newskuid = ''
          that.newskuidradio = ''
          that.$message({
            message: '修改成功',
            type: 'success'
          })
          that.tableviewModelChangeSKU()
        },
        error: function(response) {
          console.log('editskulinkconfirm', response)
        }
      })
    },

    /**
     * 切换浏览模式
     */
    chkviewmodel: function(typeid){
      this.viewmodel = typeid
      this.setLocalStorage( "viewmodel", typeid )
      // this.$router.replace({
      //   query:{
      //     page: 1
      //   }
      // }).catch(data => {})
      this.tableviewQuery.page = 1
      if(this.viewmodel == 1){
        this.tableDataskulist = []
        this.currentPage1 = 1
        if(localStorage.getItem("viewurlpage")){
          localStorage.removeItem('viewurlpage')
        }
        this.tableviewModelChangeSKU()
      }
      if(this.viewmodel == 2){
        this.tableData = []
        this.tableDataSku = []
        this.currentPage1 = 1
        if(localStorage.getItem("viewurlpage")){
          localStorage.removeItem('viewurlpage')
        }
        this.tableviewModelChange()
      }      
    },
    
    /**
     * 查看SKU模式
     */
    tableviewModelChangeSKU: function (query) {

      let that = this;
      let newQuery = {};
      let emptyQuery= {
        page: this.tableviewQuery.page,
        sku: '',
        channel: "",
        rpstatus: "",
        search: "",
        authorize: '',
      }

      that.tableloading2 = true

      newQuery = {
        ... emptyQuery,
        page: this.tableviewQuery.page,
        skuid: that.$route.params.SkuId,
        channel: that.filterselector[0].default,
        rpstatus: this.tableviewQuery.rpstatus,
        authorize: this.tableviewQuery.authorize,
        search: this.viewState.searchNeedle,
        order: this.tableorder,
        size: this.pagesize,
        ...query,
      }

      let url = this.API_URL + '/v3/price/statistics/paging';
      $.ajax({
        url:  url,
        type: "GET",
        data: newQuery,
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        success: function(rex) {
          console.log('tableviewModelChange', rex)
          let data = rex.results[1]
          data.forEach(item => {
            item.AssetIdIcon = item.HasNew/1 === 1 ? item.AssetId + ' <i class="icon-newdata-txt">New</i>' : item.AssetId
            item.channelicon = that.setChannel(item.Channel).src
            item.authorize = item.IsAuthor/1 === 0 ? that.$t('dsfx.t53') : that.$t('dsfx.t52')
            item.MarginPercent = (item.MarginPercent * 100).toFixed(2) + "%"
            item.last30days = item.statisticsCount
            item.last30times = item.statisticsDay
            item.status = item.Status
            item.RightsProtectionStatusContent = item.Status
            item.RightsProtectionStatusContentRst = that.setResults(item.Status).styleclass
            item.RightsProtectionStatusContentTxt = that.setResults(item.Status).text
            item.iseditnotes
            item.SkuTotalAmountStr = item.Channel == '拼多多' || item.Channel == '微店' ? 
                                      that.setPriorityLevel(item.TotalAmount, 0) : 
                                      that.setPriorityLevel(item.TotalAmount, 1)
          })
          item.iseditnotes = false
          item.notes = item.notes == null || item.notes == 'null' || item.notes == '' ? '' : item.notes
          that.pagingtotalsku = rex.results[0][0].Count
          that.tableloading2 = false
        },
        error: function(response) {
          console.log(response)
        }
      });
    },

    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    /* 勾选数据行 */
    handleSelectionChange(val) {
      this.feedbackSelectedIds = val
      if(this.feedbackSelectedIds != ''){
        this.ischeckeditems = false
      }else{
        this.ischeckeditems = true
      }
    },

    /**
     * 备注
     * @param {*} label 
     * @param {*} notes 
     * @param {*} sid 
     * @param {*} i 
     */
    setnote: function(assetid, notes, i){
      let that = this
      let url = that.API_URL + '/v3/price/statistics/editNotes'
      let postdata= { 
        assetId: assetid,
        notes: notes
      }
      $.ajax({
        url: url,
        type: "POST",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        contentType: "application/json",
        data: JSON.stringify(postdata),
        success: function(data) {
          console.log(data)
          that.tableData[i * 1].iseditnotes = false
        },
        error: function(response) {
          console.log(response)
        }
      })      
    },

    /**
     * 修改授权
     */
    editTableColumn: function(row, column){
      // if(column.id == 'el-table_1_column_7'){
      //   row.isedittype = true
      // }
      if(column.property == 'notes'){
        row.iseditnotes = true
      }
    },

  }  
}

</script>

<style scoped>
.el-pagination{
  float: left;
}
.el-button.el-button--confirmselect{
  height: 24px;
  padding: 0 10px;
  line-height: 24px;
  margin-top: 1px;
  border-color: #F56C6C;
  background-color: #F56C6C;
  color: #fff;
}
.el-button.el-button--confirmselect.is-disabled{
  border-color: #fab6b6;
  background-color: #fab6b6;
  color: #FFFFFF;
}
</style>